import { assistantStrategy } from './assistantStrategy';
import { chatsStrategy } from './chatsStrategy';
import { mediaStrategy } from './mediaStrategy';

const strategies = [assistantStrategy, chatsStrategy, mediaStrategy];

export const getStrategy = (assistant) => {
  if (!assistant) {
    return null;
  }

  return strategies.find((strategy) => strategy.supports(assistant)) || null;
};

export const isStrategySupported = (assistant) => {
  return getStrategy(assistant) !== null;
};
